<script>
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        components: {
            Carousel,
            Slide,
        },
        data: function () {
            return {
                monthly: false,
                showHomeVideoModal: false,
                loaded: false,
            }
        },
        mounted() {
            this.loaded = true;
        },
    }
</script>
